import { AmericanFootballIncidentId } from './american-football/IncidentId.js'
import { BaseballIncidentId } from './baseball/IncidentId.js'
import { BasketballIncidentId } from './basketball/IncidentId.js'
import { Basketball3x3IncidentId } from './basketball3x3/IncidentId.js'
import { BeachVolleyballIncidentId } from './beach-volleyball/IncidentId.js'
import { CricketIncidentId } from './cricket/IncidentId.js'
import { EmergencyIncidentId } from './emergency/index.js'
import { HandballIncidentId } from './handball/IncidentId.js'
import { IceHockeyIncidentId } from './ice-hockey/IncidentId.js'
import { RugbyLeagueIncidentId } from './rugby-league/index.js'
import { RugbyUnionIncidentId } from './rugby-union/index.js'
import { SoccerIncidentId } from './soccer/IncidentId.js'
import { VolleyballIncidentId } from './volleyball/IncidentId.js'

export enum CommonIncidentId {
  TechnicalProblems = 1200,
  MatchResumed = 1001,
  Betstop = 1010,
  Betstart = 1000,
}

export type IncidentId =
  | CommonIncidentId
  | SoccerIncidentId
  | HandballIncidentId
  | VolleyballIncidentId
  | BasketballIncidentId
  | BaseballIncidentId
  | CricketIncidentId
  | BeachVolleyballIncidentId
  | AmericanFootballIncidentId
  | Basketball3x3IncidentId
  | IceHockeyIncidentId
  | EmergencyIncidentId
  | RugbyUnionIncidentId
  | RugbyLeagueIncidentId
